import Vue from "vue";
import Vuex from "vuex";
import getters from './getters'
import user from './modules/user'
import Switchmenu from './modules/Switchmenu'
import queryForm from './modules/queryForm'
import common from './modules/common'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    Switchmenu,
    queryForm,
    common
  },
  getters
});
